// https://vuex.vuejs.org/en/actions.html
import axios from 'axios'
import jwtDecode from '../mixins/jwtDecode'

function renewLocalStorage (commit, response) {
  const token = response.data.token
  const expires_in = response.data.expires_in
  const payload = jwtDecode(token)
  const user = {
    username: payload.sub,
    fullname: payload.fullname
  }
  const permissions = payload.permissions
  localStorage.setItem('token', token)
  localStorage.setItem('expires_in', expires_in)
  localStorage.setItem('username', user.username)
  localStorage.setItem('userdata', JSON.stringify(user))
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  // mutation to change state properties to the values passed along
  user.permissions = payload.permissions // we dont store permissions in localstorage
  commit('auth_success', { token, expires_in, user, permissions })
  console.log('success reload token')
}

function removeLocalStorage () {
  localStorage.removeItem('token')
  localStorage.removeItem('expires_in')
  localStorage.removeItem('username')
  localStorage.removeItem('userdata')
}

// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  async login ({ commit, dispatch }, userData) {
    try {
      commit('auth_request')
      let response = await axios.post('/api/login', { username: userData.username, password: userData.password })
      const token = response.data.token
      let payload = jwtDecode(token)

      const user = {
        username: payload.sub,
        fullname: payload.fullname
      }
      const permissions = payload.permissions
      const expires_in = response.data.expires_in
      // storing jwt in localStorage. https cookie is safer place to store
      localStorage.setItem('expires_in', expires_in)
      localStorage.setItem('token', token)
      localStorage.setItem('username', user.username)
      localStorage.setItem('userdata', JSON.stringify(user)) // we dont store permissions in localstorage
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      // mutation to change state properties to the values passed along
      user.permissions = payload.permissions
      commit('auth_success', { token, expires_in, user, permissions })
    } catch (err) {
      commit('auth_error')
      removeLocalStorage()
    }
  },
  async logout ({ commit }) {
      commit('logout')
      removeLocalStorage()
      delete axios.defaults.headers.common['Authorization']
  },

  async syncNotification ({ commit, state }, idNotify) {
    let user = JSON.parse(localStorage.getItem('userdata'))
    if (idNotify) {
      let resp = await axios({ url: `/api/notification/mark?id=${idNotify}&username=${user.username}`, method: 'POST' })
      console.debug(resp)
    }
    let response = await axios({ url: `/api/notification/latest?username=${user.username}`, method: 'GET' })
    console.debug(response)
    let data = response.data
    commit('setNotification', { data })
    return data
  },

  async refreshtoken ({ commit }) {
    try {
      let response = await axios.get('/api/refresh')
      console.log('success /refresh: ')
      renewLocalStorage(commit, response)
    } catch (error) {
      console.log('refresh token error')
      commit('logout')
      removeLocalStorage()
      console.log(error)
      window.location.reload()
    }
  },
  async uploadFile ({ commit }, { filexls, endpoint }) {
    try {
      let formData = new FormData()
      formData.append('file', filexls)
      return await axios.post(`/${endpoint}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    } catch (error) {
      console.log(error)
    }
  },
  async postFormData ({ commit }, { file, tableItem, endpoint }) {
    try {
      let formData = new FormData()
      if (file instanceof File) {
        formData.append('file', file)
      }
      let json = JSON.stringify(tableItem)
      formData.append('json', json)
      return await axios.post(`/${endpoint}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            console.log(progressEvent.loaded + ' : ' + progressEvent.total)
            // this.updateProgressBarValue(progressEvent)
          }
        }
      })
    } catch (error) {
      console.log(error)
    }
  },

  async reloadPermissions ({ commit, state }) {
    if (!state.permissions || state.permissions.length === 0) {
      const claim = jwtDecode(localStorage.getItem('token'))
      const permissions = claim.permissions || []
      console.debug('reload permission from token in local storage')
      console.debug(claim)
      commit('setPermissions', { permissions })
    }
  },

  async autoRefreshToken ({ commit }) {
    const expiresIn = localStorage.getItem('expires_in')
    const interval = (!expiresIn || expiresIn === 0 ? 30 * 60 * 1000 : expiresIn) - 30 * 1000
    console.debug(`AutoRefreshToken : expires(ms)=${expiresIn}, interval(ms)=${interval}`)
    // code goes here that will be run every based on "expiresIn" minus 30s.
      setInterval(async function () {
        try {
          console.debug('silent refresh running')
          let response = await axios.get('/api/refresh')
          renewLocalStorage(commit, response)
        } catch (error) {
          console.debug('silent refresh token error')
          commit('logout')
          removeLocalStorage()
          console.log(error)
          window.location.reload()
        }
      }, interval)
  },

  getTableList ({ commit }, endpoint) {
    this.$http.get(`/${endpoint}`)
      .then(response => {
        let tableList = response.data.content
        commit('setTableList', { tableList })
      })
      .catch(error => console.log(error))
  },

  updateTableItem ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({ url: `/${tableData.endpoint}`, method: httpmethod, data: tableData.tableItem })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  // I had struggling to show <img> in both ways (base64 or blob/binary) thus we disabled security in BE service.
  async getSecuredImage ({ commit }, imageData) {
    try {
      let response = await axios.get(`${imageData.endpoint}`, {
        headers: {
          'accept': 'image/*',
          'responseType': 'arraybufffer'
        }
      })

      let el = document.querySelector('#' + imageData.containerId)
      // let reader = new window.FileReader()
      // reader.readAsDataURL(response.data)
      // reader.onload = () => {
      //   let imageDataUrl = reader.result
      //   el.setAttribute('src', imageDataUrl)
      // }
      // img.style.backgroundImage = `url(${url})`

      // Create a binary string from the returned data, then encode it as a data URL.
      var base64data = new Buffer(response.data, 'binary').toString('base64')

      el.src = 'data:image/png;base64,' + base64data
    } catch (error) {
      console.log(error)
      // document.querySelector('#' + imageData.containerId).src = require('@/assets/img/redditicon.png')
    }
  }
}
